<template>
  <div>
    <section class="form-scroll">
      <div class="form" v-show="step == 1">
        <form @submit.prevent="" id="step1">
          <input type="hidden" name="landing_type" value="cash">
          <input type="hidden" name="is_usedcar" value="on">
          <!-- <div class="form-before-img">
            <img class="form-before-img_dt lazyload" data-src="/img/cash-credit-landing/cake.png">
            <img class="form-before-img_mb lazyload" data-src="/img/cash-credit-landing/form-girl-mob.png">
          </div> -->
          <!-- <div class="form-after-img">
            <img class="form-after-img_dt lazyload" data-src="/img/cash-credit-landing/form-men.png">
            <img class="form-after-img_mb lazyload" data-src="/img/cash-credit-landing/form-men-mob.png">
          </div> -->
          <div class="wrapper">

            <div class="half-from-block">
              <div class="form-title">
                {{ __t('Заповніть анкету та дізнайтеся рішення Банку онлайн') }}
              </div>
              <div class="range-input-group">
                <div class="input-field range-input-field">
                  <label for="limit">{{ __t('Бажана сума кредиту, грн') }}</label>
                  <div class="input-hint-wrapper">
                    <div class="range-container">
                      <input type="tel"
                             class="limit"
                             name='sum_credit'
                             id="limit"
                             :min="form.credit.min"
                             :max="form.credit.max"
                             v-model.number="form.credit.value"
                             @input="getValue()"
                             :placeholder="form.credit.value"
                             ref="limit"
                             v-numericOnly
                             v-mask="setMask"
                             tabindex="0">
                      <div class="line"></div>
                      <div class="line-green"></div>
                    </div>
                  </div>
                  <div id="range-slider"></div>
                </div>
                <div class="input-field diapason ">
                  <div class="from">{{ form.credit.min }}</div>
                  <div class="to">{{ form.credit.max }}</div>
                </div>
              </div>
              <div class="range-input-group">
                <div class="input-field range-input-field">
                  <label for="limit_2">{{ __t('Строк кредиту, міс') }}</label>
                  <div class="range-container">
                    <input type="tel"
                           class="limit"
                           name='term_credit'
                           id="limit_2"
                           :min="form.monthInt.min"
                           :max="form.monthInt.max"
                           v-model.number="form.monthInt.value"
                           @input="getValue()"
                           :placeholder="form.monthInt.value"
                           ref="limit_2"
                           v-numericOnly
                           v-mask="'###'"
                           tabindex="0">
                    <div class="line"></div>
                    <div class="line-green"></div>
                  </div>
                  <div id="range-slider_2"></div>
                </div>
                <div class="input-field diapason">
                  <div class="from">{{ form.monthInt.min }}</div>
                  <div class="to">{{ form.monthInt.max }}</div>
                </div>
              </div>
              <div class="month-pay">
                <div class="month-pay_title">
                  <p>{{ __t('Щомісячний платіж, грн') }}</p>
                </div>
                <div class="month-pay_price">
                  <p>{{ monthPaySumLabel }}</p>
                </div>
              </div>

            </div>
            <div class="half-from-block">
              <div class="input-field">
                <label for="lname">{{ __t('Фамилия первый шаг') }}</label>
                <input type="text"
                       id="lname"
                       placeholder="Введіть своє прізвище"
                       name='client_surname'
                       v-lettericOnly
                       autocomplete="off"
                       tabindex="0"
                >
                <div v-show="typeof errorValidation.client_surname !== 'undefined'">
                  <label class="error_back" style="color: red"
                         v-for="(error, idx) in errorValidation.client_surname"
                         :key="idx">{{ error }}</label>
                </div>
              </div>

              <div class="input-field-group">
                <div class="input-field">
                  <label for="fname">{{ __t('Имя первый шаг') }}</label>
                  <input type="text"
                         id="fname"
                         placeholder="Введіть свое ім’я"
                         @change="clientName($event.target.value)"
                         name='client_name'
                         v-lettericOnly
                         autocomplete="off"
                         tabindex="0">

                  <div v-show="typeof errorValidation.client_name !== 'undefined'">
                    <label class="error_back" style="color: red"
                           v-for="(error, idx) in errorValidation.client_name"
                           :key="idx">{{ error }}</label>
                  </div>
                </div>
                <div class="input-field">
                  <label for="mname">{{ __t('Отчество') }}</label>
                  <input type="text"
                         id="mname"
                         :placeholder="__t('Вкажіть Ваше ім’я по батькові')"
                         name='client_middlename'
                         v-lettericOnly
                         autocomplete="off"
                         tabindex="0"
                  >
                  <div v-show="typeof errorValidation.client_middlename !== 'undefined'">
                    <label class="error_back" style="color: red"
                           v-for="(error, idx) in errorValidation.client_middlename"
                           :key="idx">{{ error }}</label>
                  </div>
                </div>
              </div>

              <div class="input-field">
                <label v-if="cookie" style="color: red">{{ __t('Нам прикро.') }}<br>
                  {{ __t('Спробуйте завести заявку ще раз через') }} {{ cashsettings.block_time }}
                  хвилин.
                </label>
                <template v-if="!cookie">
                  <label for="phone">{{ __t('Номер телефону') }}</label>
                  <input type="tel"
                         id="phone"
                         name='client_phone'
                         inputmode="tel"
                         @input.lazy="setPhone($event.target.value)"
                         placeholder="+38 (0__) ___-__-__"
                         v-mask="'+380(##) ###-####'"
                         @input="hideBackEndError"
                         tabindex="0"
                  >
                  <div v-show="typeof errorValidation.client_phone !== 'undefined'">
                    <label class="error_back" style="color: red"
                           v-for="error in errorValidation.client_phone">{{ error }}</label>
                  </div>
                </template>
              </div>
              <div class="input-field birthday-field">
                <label for="dobday">{{ __t('Дата народження') }}</label>
                <div>
                  <input type="tel" name='client_date_of_birth'
                         v-mask="'##.##.####'"
                         ref="minAge" class="birthday"
                         placeholder="ДД.ММ.РРРР"
                         v-model="client_birthday"
                         style="opacity: 0; visibility: hidden; position: absolute; z-index: -1000"
                         tabindex="0"
                  />

                  <div class="input-field-group birthday-field__group">
                    <div class="select-wrapper dobday">
                      <select id="dobday" v-model="date_birthday.day_birthday" tabindex="0"></select>
                      <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
                    </div>
                    <div class="select-wrapper dobmonth">
                      <select id="dobmonth" v-model="date_birthday.month_birthday" tabindex="0"></select>
                      <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
                    </div>
                    <div class="select-wrapper dobyear">
                      <select id="dobyear" v-model="date_birthday.year_birthday" tabindex="0"></select>
                      <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
                    </div>
                  </div>

                  <p>{{ __t('мінімальний вік для отримання кредиту - cash') }}</p>
                </div>

                <div v-show="typeof errorValidation.client_date_of_birth !== 'undefined'">
                  <label class="error_back" style="color: red"
                         v-for="error in errorValidation.client_date_of_birth">{{ error }}</label>
                </div>
              </div>

              <div class="input-field">
                <label for="activities">{{ __t('Тип зайнятості') }}</label>
                <div class="select-wrapper">
                  <select name="applicant_type" v-model="type_activity" id="activities"
                          class="required activities" tabindex="0">
                    <option selected value="">{{ __t('Оберіть тип зайнятості') }}</option>
                    <option :value="option.code" v-for="option in typesubjects">{{ option.title }}
                    </option>
                  </select>

                  <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
                  <div v-show="typeof errorValidation.applicant_type !== 'undefined'">
                    <label class="error_back" style="color: red"
                           v-for="error in errorValidation.applicant_type">{{ error }}</label>
                  </div>
                </div>

              </div>
              <button
                  v-show="!hiddenSubmitButton"
                  :disabled="!agree"
                  id="send-form"
                  class="btn red-btn asd"
                  ref="sendForm"
                  tabindex="0">
                {{ __t('Далі') }}
              </button>

              <div v-show="!hiddenSubmitButton" class="arrow-bottom_container">

                <div data-size="invisible" class="g-recaptcha" id="g-recaptcha-callback-popup"></div>
                <input type="hidden" name="g-recaptcha-response" class="g-recaptcha-response"
                       :value="responseRecaptcha">

                <div class="input-field">
                  <label tabindex="0" @keydown.space.prevent="agree = !agree" @keydown.enter.prevent="agree = !agree">
                    <div class="input-field_checkbox" :style="{background : agree ? '#ABEA47' : '#E8E8E8'}">
                      <img v-if="agree" src="/img/cash-credit-landing/check.png">
                      <input type="checkbox" name="agree" v-model="agree" id="agree">
                    </div>
                    {{ __t('Підтверджую надання') }}
                  </label>
                </div>

                <button type="button" class="arrow-button" tabindex="0"
                        @click="openPopupAgreement()">
                  {{ __t('згоди на оброблення персональних даних') }}
                  <img src="/img/credit-landing-vue/arrow-right-light.svg" alt="Arrow right">
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <step2 v-show="step == 2"
             v-on:goback="goback()"
             v-on:gonext="gonext()"
             v-on:fatalEvent="fatalEvent"
             :phone='phone'
             @closePreloader="closePreloader"
             @openPreloader="openPreloader"
             @openPopupAgreementSms="openPopupAgreementSms"

      ></step2>
      <step-gate
          v-show="step == 3"
          v-on:gonext="gonext()"
          @closePreloader="closePreloader"
          @openPreloader="openPreloader"
          @exitForm="popupWithManagerShow = true; focusOnClose()"
      ></step-gate>
      <step3 v-show="step == 4"
             v-on:goback="goback()"
             v-on:gonext="gonext()"
             :maritalstatus="maritalstatus"
             :housingstatus='housingstatus'
             :client_birthday="client_birthday"
             :type_activity="type_activity"
             :client_ipn="client_ipn"
             @openIpnPopup="openIpnPopup($event)"
             @changeStep="onChangeStep($event)"
             @closePreloader="closePreloader"
             @openPreloader="openPreloader"
             ref="step3"
             @overStep="step = 5"

      ></step3>
      <step4 v-show="step == 5"
             v-on:goback="goback()"
             v-on:success="popupSuccessShow = true; focusOnClose()"
             v-on:error="popupErrorShow = true; focusOnClose()"
             v-on:call="popupCallShow = true; focusOnClose()"
             v-on:returnbegin="step = 1;"
             @changeStep="onChangeStep($event)"
             @closePreloader="closePreloader"
             @openPreloader="openPreloader"
             :typesubjects="typesubjects"
             :employerownership="employerownership"
             :type_activity="type_activity"
             :positions="positions"
             :activities="activities"
             :regions="regions"
             :taxsystem="taxsystem"
             :activitieskind="activitieskind"
             :periodforfop3="periodforfop3"
             :quarterperiod="quarterperiod"
      ></step4>
      <!-- <step5 v-show="step == 6"
             v-on:goback="goback()"
             v-on:success="popupSuccessShow = true; focusOnClose()"
             v-on:error="popupErrorShow = true; focusOnClose()"
             v-on:call="popupCallShow = true; focusOnClose()"
             :type_activity="type_activity"
             :maritalstatus="maritalstatus"
             v-on:returnbegin="step = 1;"
             @closePreloader="closePreloader"
             @openPreloader="openPreloader"
             @overStep="step = 3"

      ></step5> -->

      <popup-contract ref="popup_contract"></popup-contract>
      <popup-contract-sms ref="popup_contractSms"></popup-contract-sms>
      <popup-services-error ref="popup_servicesError"></popup-services-error>
      <popup-success ref="popup_success"
                     v-if="popupSuccessShow"
                     v-on:popupSuccessHide="popupSuccessHide()">

      </popup-success>
      <popup-with-manager ref="popup_with_manager"
                     v-if="popupWithManagerShow"
                     v-on:popupSuccessHide="popupSuccessHide()">
      </popup-with-manager>

      <popup-callback-success ref="popup_callback_success"
                              v-if="popupCallbackSuccessShow"
                              v-on:popupCallbackSuccessHide="popupCallbackSuccessHide()">

      </popup-callback-success>

      <popup-error ref="popup_error"
                   v-if="popupErrorShow"
                   v-on:popupErrorHide="popupErrorHide()"
                   :errorMessage="errorMessage">

      </popup-error>
      <popup-error-phone ref="popup_error_phone"
                         v-if="popupErrorPhoneShow"
                         v-on:popupErrorHide="popupErrorPhoneHide()">

      </popup-error-phone>
      <popupReplayError ref="popup_replayError"
                        v-if="popupReplayError"
                        v-on:popupReplayErrorHide="popupReplayErrorHide()">
      </popupReplayError>

      <popupCall ref="popup_call"
                 v-if="popupCallShow"
                 v-on:popupRefusingHide="popupRefusingHide()">

      </popupCall>

      <popup-callback ref="popupCallback"
                      @popup-success="popupCallbackSuccessShow = true; focusOnClose()"
                      @popup-error="popupErrorShow = true; focusOnClose()"
                      @closePreloader="closePreloader"
                      @openPreloader="openPreloader"
                      @clicked="checkTimer"
                      :client_name="client_name"
                      :phone="phone"></popup-callback>
      <popup-IPN ref="popupIPN"
                 :client_birthday="client_birthday"
                 :client_ipn="client_ipn"

                 :min_age="min_age"
                 :max_age="max_age"
                 :type_activity="type_activity"
                 @gonext="step = 5"
                 @changeIPNandDate="changeIPNandDate($event)"
                 @doAllRight="doAllRight"
                 @call="popupCallShow = true; step = 1; popupCallShow = true; clearForm(); resetValue()"
                 @error="popupErrorShow = true; step = 1; clearForm(); resetValue()"
                 @doRequest="$refs.step3.doRequest()"
                 @clearForm="clearForm(); resetValue()"
                 @overStep="step = 5"
                 @update="update($event)"
      ></popup-IPN>

      <step-preloader ref="step_preloader"></step-preloader>
    </section>
    <section>
      <div class="your-credit ">
        <div class="wrapper">
          <div class="your-credit_container">
            <div class="your-credit_title">
              <h3>{{ __t('З чого складається ваш кредит') }}</h3>
            </div>
            <div class="your-credit_block">
              <div class="your-credit_range-group fw">
                <div class="your-credit_range">
                  <div class="input-field range-input-field">
                    <label for="limit_3">{{ __t('Cума кредиту, грн') }}</label>
                    <div class="range-container">
                      <div class="line"></div>
                      <div class="line-green"></div>
                    </div>
                    <div id="range-slider_3"></div>
                  </div>
                  <div class="input-field diapason fw">
                    <div class="between" v-for="count in form.credit.between" :style="{ left: creditBulletPosition(count) + '%' }"><span>{{ count }}</span></div>
                  </div>
                </div>
                <div class="your-credit_range">
                  <div class="input-field range-input-field">
                    <label for="limit_4">{{ __t('Cтрок кредиту, міс') }}</label>
                    <div class="range-container">
                      <div class="line"></div>
                      <div class="line-green"></div>
                    </div>
                    <div id="range-slider_4"></div>
                  </div>
                  <div class="input-field diapason fw">
                    <div class="between" v-for="count in form.monthInt.between" :style="{ left: monthBulletPosition(count) + '%' }"><span>{{ count }}</span></div>
                  </div>
                </div>
              </div>
              <div class="your-credit-block_items-wrap">
                <div class="your-credit-block_item your-credit_month-pay fw">
                  <div class="your-credit-block_title">
                    <p>{{ __t('Щомісячний платіж, грн') }}:</p>
                  </div>
                  <div class="your-credit-block_count">
                    <p>{{ monthPaySumLabel }}</p>
                  </div>
                </div>
                <div class="your-credit-block_item fw"
                     v-for="(item, key) in calcItems">
                  <div class="your-credit-block_title">
                    <p>{{ item.label }}</p>
                  </div>
                  <div class="your-credit-block_count">
                    <p>{{ item.value }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="button-wrapper page-bottom ">
            <a class="single-button btn violet-btn colored-btn" tabindex="0" @click="scrollToForm" @keydown.enter.prevent="scrollToForm">{{ __t('Отримати кредит') }}</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import step2 from './step2';
import step3 from './step3';
import step4 from './step4';
import step5 from './step5';

import Switcher from '../../components/Form/Switcher';
import stepPreloader from './step_preloader';
import popupContract from './popup_contract'
import popupContractSms from './popup_contract-sms'
import popupError from './popup_error'
import popupErrorPhone from "./popup_error_phone";
import popupServicesError from './popup_services-error.vue';
import PopupSuccess from "./popup_success";
import PopupWithManager from './popup_with_manager.vue'
import popupCallback from './popup_callback'
import popupIPN from './popup_IPN'
import popupReplayError from './popup_replay-error'
import popupCall from './popup_call'
import PopupCallbackSuccess from "./popup_callback_success";
import moment from 'moment-timezone';
import xirr from 'xirr';
import readCookie from '../../utils/readCookie';
import createCookie from '../../utils/createCookie';
import StepGate from './stepGate.vue';

export default {
  name: "Main",
  components: {
    step2,
    step3,
    step4,
    step5,
    StepGate,
    Switcher,
    popupContract,
    popupContractSms,
    popupError,
    popupErrorPhone,
    PopupSuccess,
    popupCallback,
    PopupCallbackSuccess,
    popupIPN,
    popupServicesError,
    stepPreloader,
    popupReplayError,
    popupCall,
    PopupWithManager
  },
  props: [
    'typesubjects',
    'cashsettings',
    'clientyearmin',
    'clientyearmax',
    'housingstatus',
    'timer',
    'maritalstatus',
    'positions',
    'employerownership',
    'regions',
    'activities',
    'taxsystem',
    'activitieskind',
    'summax',
    'summin',
    'termmin',
    'termmax',
    'periodforfop3',
    'cookie',
    'quarterperiod',
    'popupCall',
    'abandoned',
    'percentrates',
    'creditBetween',
    'monthBetween'
  ],
  data() {
    return {
      form: {
        credit: {
          placeholder: '0',
          value: this.summin,
          min: this.summin,
          between: [],
          max: this.summax
        },
        monthInt: {
          placeholder: '0',
          value: this.termmin,
          min: this.termmin,
          between: [],
          max: this.termmax
        },

        difficult_form: "",
        percentrate: 55,
        monthlyCommission: 1.8,
        lifeInsurance: 12.99,
        SumLifeInsurance: 0,
        totalCredit: 0,
      },
      isCurrentAccount: false,
      min_age: this.clientyearmin,
      max_age: this.clientyearmax,
      step: 1,
      phone: '',
      client_name: "",
      client_ipn: "",
      client_birthday: this.default__birthday,
      errorValidation: {},
      type_activity: '',
      hiddenSubmitButton: true,
      popupErrorShow: false,
      popupErrorPhoneShow: false,
      popupSuccessShow: false,
      popupWithManagerShow: false,
      popupCallbackSuccessShow: false,
      popupReplayError: false,
      popupCallShow: false,
      reloadAfterClosePopup: true,
      responseRecaptcha: null,
      errorMessage: 'Згідно з нашими вимогами до позичальників, ми наразі не можемо надати вам кредит',

      date_birthday: {
        day_birthday: '',
        month_birthday: '',
        year_birthday: '',
      },
      options_birthday_picker: {
        daySelector: '#dobday',
        monthSelector: '#dobmonth',
        yearSelector: '#dobyear',
        minimumAge: 23,
        maximumAge: 47,
        dayDefault: 'День',
        monthDefault: 'Місяць',
        yearDefault: 'Рік',
      },
      agree: false
    }
  },
  methods: {
    focusOnClose() {
      this.$nextTick(() => {
        setTimeout(() => {
          const btn = document.querySelector('#closePopupFocusId');
          if (btn) {
            btn.focus()
          }
        }, 50);
      });
    },
    clientName(e) {
      this.client_name = e.replace(/[^а-щА-ЩЬьЮюЯяЇїІіЄєҐґ\s\'\-]/g, '');
    },
    popupErrorHide() {
      this.popupErrorShow = false;
      this.$refs.popupCallback.$el.style.display = 'none';
      if (this.reloadAfterClosePopup) {
        location.href = location.href;
      }
      this.reloadAfterClosePopup = true;
    },
    popupErrorPhoneHide() {
      this.popupErrorPhoneShow = false;
      this.focusOnClose();
      this.$refs.popupCallback.$el.style.display = 'none';
      if (this.reloadAfterClosePopup) {
        location.href = location.href;
      }
    },
    popupReplayErrorHide() {
      this.popupReplayError = false;
      this.$refs.popupCallback.$el.style.display = 'none';
      if (this.reloadAfterClosePopup) {
        location.href = location.href;
      }
      this.reloadAfterClosePopup = true;
    },
    popupRefusingHide() {
      this.popupCallShow = false;
      this.$refs.popupCallback.$el.style.display = 'none';
      location.href = location.href;
    },
    popupSuccessHide() {
      this.popupSuccessShow = false;
      this.$refs.popupCallback.$el.style.display = 'none';
      if (this.reloadAfterClosePopup) {
        location.href = location.href;
      }
      this.reloadAfterClosePopup = true;
    },

    popupCallbackSuccessHide() {
      this.popupCallbackSuccessShow = false;
      this.$refs.popupCallback.$el.style.display = 'none';
      if (this.reloadAfterClosePopup) {
        location.href = location.href;
      }
      this.reloadAfterClosePopup = true;
    },

    roundToNearestTen(number) {
      const roundedWithoutZeros = Math.floor(number / 10000) + (number % 10000 >= 5000);
      return roundedWithoutZeros * 10000;
    },

    calcCreditBetween() {
      if (!this.creditBetween || this.creditBetween.length === 0) {
        this.form.credit.between[0] = this.summin;
        this.form.credit.between[1] = this.roundToNearestTen(Math.ceil((this.summax / 100 * 25)));
        this.form.credit.between[2] = this.roundToNearestTen(Math.ceil((this.summax / 100 * 50)));
        this.form.credit.between[3] = this.roundToNearestTen(Math.ceil((this.summax / 100 * 75)));
        this.form.credit.between[4] = this.summax;
      } else {
        this.form.credit.between = [this.summin, ...this.creditBetween, this.summax]
      }
    },
    calcMonthBetween() {
      if (!this.monthBetween || this.monthBetween.length === 0) {
        this.form.monthInt.between[0] = this.termmin;
        this.form.monthInt.between[1] = Math.ceil(this.termmax / 100 * 29)+1;
        this.form.monthInt.between[2] = Math.ceil(this.termmax / 100 * 48);
        this.form.monthInt.between[3] = Math.ceil(this.termmax / 100 * 69)-1;
        this.form.monthInt.between[4] = Math.ceil(this.termmax / 100 * 80)+1;
        this.form.monthInt.between[5] = this.termmax;
      } else {
        this.form.monthInt.between = [this.termmin, ...this.monthBetween, this.termmax]
      }
    },
    creditBulletPosition(count) {
      return this.bulletPosition(count, this.summin, this.summax)
    },
    monthBulletPosition(count) {
      return this.bulletPosition(count, this.termmin, this.termmax)
    },
    bulletPosition(count, min, max) {
      return (count - min) / (max - min) * 100;
    },
    fatalEvent() {
      this.cookie = true;
      this.$refs.sendForm.disabled = this.cookie;
    },
    hideBackEndError(el) {
      this.errorValidation.client_phone = [];
    },
    doAllRight() {
      this.$refs.step3.doAllRight()
    },
    changeIPNandDate(el) {
      this.client_ipn = el.new_client_ipn;
      this.client_birthday = el.new_client_birthday;

      this.$refs.step3.setIpn(el.new_client_ipn);
    },
    openIpnPopup(e) {
      this.client_ipn = e;
      this.$refs.popupIPN.popupShow()
    },
    showCallbackResult() {
      this.popupSuccessShow = true;
    },
    openPopupAgreement() {
      this.$refs.popup_contract.popupOpen();
    },
    openPopupAgreementSms() {
      this.$refs.popup_contractSms.popupOpen();
    },
    openServicesErrorPopup() {
      this.$refs.popup_servicesError.popupShow();
    },
    openPopupCallback: function () {
      this.$refs.popupCallback.popupShow();
    },
    setPhone(value) {
      this.phone = value;

    },
    goback() {
      this.step--;

    },
    gonext() {
      this.step++;

    },
    openPreloader() {
      this.$refs.step_preloader.preloaderOpen();
    },
    closePreloader() {
      this.$refs.step_preloader.preloaderClose();
    },
    onChangeStep(val) {
      this.step = val;
    },
    __t(phrase) {
      return window.__t(phrase);
    },
    creditParamsCalculate: function () {
      if (this.percentrates.length) {
        if (this.isCurrentAccount) {
          this.percentrates.forEach((el) => {
            if (Math.round(this.form.credit.value) >= el.min_for_client && Math.round(this.form.credit.value) <= el.max_for_client) {
              this.form.percentrate = Math.round(el.percent_for_client);
            }
          });
        } else {
          this.percentrates.forEach((el) => {
            if (Math.round(this.form.credit.value) >= el.min && Math.round(this.form.credit.value) <= el.max) {
              this.form.percentrate = Math.round(el.percent);
            }
          });
        }
      }

      this.form.lifeInsurance = 0;
    },
    getValue: function () {
      this.rangeSlider();
      $("#range-slider").slider("option").value = this.form.credit.value;
      this.rangeSlider();
      $("#range-slider_2").slider("option").value = this.form.monthInt.value;
      this.rangeSlider();
      $("#range-slider_3").slider("option").value = this.form.credit.value;
      this.rangeSlider();
      $("#range-slider_4").slider("option").value = this.form.monthInt.value;

    },
    resetValue: function () {
      $("#range-slider").slider("option").value = this.form.credit.min;
      $("#range-slider_3").slider("option").value = this.form.credit.min;
      this.form.credit.value = this.form.credit.min;
      $(this.$refs.limit).val(this.form.credit.min);
      $(this.$refs.limit_3).val(this.form.credit.min);
      this.rangeSlider();

      $("#range-slider_2").slider("option").value = this.form.monthInt.min;
      $("#range-slider_4").slider("option").value = this.form.monthInt.min;
      this.form.monthInt.value = this.form.monthInt.min;
      $(this.$refs.limit_2).val(this.form.monthInt.min);
      $(this.$refs.limit_4).val(this.form.monthInt.min);
      this.rangeSlider();
    },
    rangeSlider: function () {
      let $this = this.$refs;
      let thisVue = this;
      $("#range-slider").slider({
        min: Number($this.limit.getAttribute('min')),
        max: Number($this.limit.getAttribute('max')),
        step: 1000,
        range: "min",
        value: Number($this.limit.value),
        slide: function (event, ui) {

          thisVue.form.credit.value = ui.value;
          $this.limit.value = ui.value;
          thisVue.rangeSlider();
        },

      });
      $("#range-slider_2").slider({
        min: Number($this.limit_2.getAttribute('min')),
        max: Number($this.limit_2.getAttribute('max')),
        step: 1,
        range: "min",
        value: Number($this.limit_2.value),
        slide: function (event, ui) {
          thisVue.form.monthInt.value = ui.value;
          $this.limit_2.value = ui.value;
          thisVue.rangeSlider();
        },
      });
      $("#range-slider_3").slider({
        min: Number($this.limit.getAttribute('min')),
        max: Number($this.limit.getAttribute('max')),
        step: 1000,
        range: "min",
        value: Number($this.limit.value),
        slide: function (event, ui) {
          thisVue.form.credit.value = ui.value;
          $this.limit.value = ui.value;
          thisVue.rangeSlider();
        },
      });
      $("#range-slider_4").slider({
        min: Number($this.limit_2.getAttribute('min')),
        max: Number($this.limit_2.getAttribute('max')),
        step: 1,
        range: "min",
        value: Number($this.limit_2.value),
        slide: function (event, ui) {
          thisVue.form.monthInt.value = ui.value;
          $this.limit_2.value = ui.value;
          thisVue.rangeSlider();
        },
      });

      this.creditParamsCalculate();
    },
    clearForm() {
      if (document.getElementById('step1')) {
        document.getElementById('step1').reset();
      }
      this.client_birthday = '';
      this.client_name = '';
      this.phone = '';
      this.type_activity = '';
    },
    validation: function () {
      let self = this;

      $.validator.addMethod("selectRequired", function (value, element, arg) {
        return arg !== value;
      }, 'Оберіть один з варіантів');

      $.validator.addMethod("mobileValidate", function (value, element, arg) {
        if (value) {
          const phoneCodes = [
            '039',
            '050',
            '053',
            '067',
            '063',
            '066',
            '068',
            '073',
            '075',
            '077',
            '091',
            '092',
            '093',
            '094',
            '095',
            '096',
            '097',
            '098',
            '099',
          ];

          const phoneWithCode = value.replace(/[^0-9+]/g, '');
          let clearPhone, code;

          if (/^\+38/gi.test(phoneWithCode)) {
            code = phoneWithCode.slice(3, 6);
            clearPhone = phoneWithCode.slice(6);
          } else {
            code = phoneWithCode.slice(0, 3);
            clearPhone = phoneWithCode.slice(3);
          }

          return clearPhone.length === 7 && phoneCodes.includes(code);
        }

        return false;

      }, 'Некоректний формат номеру телефона');

      $.validator.addMethod("mobileValidateLength", function (value, element, arg) {
        const phoneWithCode = value.replace(/[^0-9+]/g, '');
        let clearPhone, code;

        if (/^\+38/gi.test(phoneWithCode)) {
          code = phoneWithCode.slice(3, 6);
          clearPhone = phoneWithCode.slice(6);
        } else {
          code = phoneWithCode.slice(0, 3);
          clearPhone = phoneWithCode.slice(3);
        }

        return clearPhone.length === 7;

      }, 'Некоректний формат номеру телефона');

      $.validator.addMethod("edrpo", function (value, element, arg) {
        return value.length == 8 || value.length == 0 ? true : false;
      }, 'Виправте код');

      $.validator.addMethod("edrpoinn", function (value, element, arg) {
        const isInn = Boolean(+element.dataset.isInn);
        const valLength = isInn ? 10 : 8;
        return value.length == valLength || value.length == 0 ? true : false;
      }, 'Виправте код');

      $.validator.addMethod("normalDate", function (value, element, arg) {
        var arrD = value.split(".");
        arrD[1] -= 1;
        var d = new Date(arrD[2], arrD[1], arrD[0]);
        if ((d.getFullYear() === Number(arrD[2])) && (d.getMonth() === Number(arrD[1])) && (d.getDate() === Number(arrD[0]))) {
          return true;
        } else {
          return false;
        }
      }, 'Виправте дату');

      $.validator.addMethod("minAge", function (value, element, arg) {
        var arrD = value.split(".");
        arrD[1] -= 1;
        var d = new Date(arrD[2], arrD[1], arrD[0]);
        let minDate = new Date();
        let age = self.min_age;
        minDate.setFullYear(minDate.getFullYear() - age);
        if (d <= minDate) {
          return true;
        } else {
          return false;
        }
      }, 'Умова по віку не виконується');

      $.validator.addMethod("maxAge", function (value, element, arg) {
        var arrD = value.split(".");
        arrD[1] -= 1;
        var d = new Date(arrD[2], arrD[1], arrD[0]);
        let maxDate = new Date();
        let age = self.max_age;
        maxDate.setFullYear(maxDate.getFullYear() - (age + 1));
        if (d >= maxDate) {
          return true;
        } else {
          return false;
        }
      }, 'Умова по віку не виконується');

      $.validator.addMethod("requiredDate", function (value, element, arg) {
        if (value.length !== 0) {
          if (Boolean($('.birthday-field__group'))) {
            $('.birthday-field__group').removeClass('error');
          }
          return true;
        }

        if (Boolean($('.birthday-field__group'))) {
          $('.birthday-field__group').addClass('error');
        }
        return false;
      })

      $.validator.addMethod("regDay", function (value, element, arg) {
        let val = value.split('.');
        let month, day, year, result;
        let today = new Date();
        if (val.length > 1) {
          year = val[2];
          month = val[1];
          day = val[0];

          if (Number(day) == 0 || Number(month) == 0 || Number(year) == 0) {
            result = false;
          } else {

            if (Number(year) < today.getFullYear() && today.getFullYear() - Number(year) <= 90) {

              result = true;

            } else if (Number(year) == today.getFullYear() && today.getFullYear() - Number(year) <= 90) {
              if (Number(month) < today.getMonth() + 1) {
                result = true
              } else if (Number(month) == today.getMonth() + 1) {
                result = Number(day) <= today.getDate();
              }
            } else {
              result = false;
            }

          }

          // Number(month) <= today.getMonth() + 1  && Number(day) <= today.getDate();
        } else {
          year = val[0];
          result = Number(year) <= today.getFullYear() && today.getFullYear() - Number(year) <= 90;
          console.log(result)
        }

        if (result) {
          return true;
        } else {
          return false;
        }

      }, 'Виправте дату');

      $.validator.addMethod("regDayNew", function (value, element, arg) {
        let val = value.split('.');
        let month, day, year, result;
        let today = new Date();
        if (val.length > 1) {
          year = val[2];
          month = val[1];
          day = val[0];

          if (Number(day) == 0 || Number(month) == 0 || Number(year) == 0) {
            result = false;
          } else {

            if (Number(year) < today.getFullYear() && today.getFullYear() - Number(year) <= 1000) {

              result = true;

            } else if (Number(year) == today.getFullYear() && today.getFullYear() - Number(year) <= 1000) {
              if (Number(month) < today.getMonth() + 1) {
                result = true
              } else if (Number(month) == today.getMonth() + 1) {
                result = Number(day) <= today.getDate();
              }
            } else {
              result = false;
            }

          }

          // Number(month) <= today.getMonth() + 1  && Number(day) <= today.getDate();
        } else {
          year = val[0];
          result = Number(year) <= today.getFullYear() && today.getFullYear() - Number(year) <= 90;
          console.log(result)
        }

        if (result) {
          if (Boolean($('.birthday-field__group'))) {
            $('.birthday-field__group').removeClass('error');
          }
          return true;
        } else {
          if (Boolean($('.birthday-field__group'))) {
            $('.birthday-field__group').addClass('error');
          }
          return false;
        }

      }, 'Виправте дату');

      $.validator.addMethod("apartmentDate", function (value, element, arg) {
        let today = new Date();

        if ($('input[name="apartment_year"]').val() == today.getFullYear()) {
          if (value > today.getMonth() + 1) {
            return false;
          } else {
            return true;
          }

        } else {
          return true;
        }

      }, 'Виправте місяць');
      $.validator.addMethod("startWork", function (value, element, arg) {
        let today = new Date();

        if ($('input[name="year"]').val() == today.getFullYear()) {
          if (value > today.getMonth() + 1) {
            return false;
          } else {
            return true;
          }

        } else {
          return true;
        }

      }, 'Виправте місяць');

      $.validator.addMethod('regexp', function (value, element, params) {
        var expression = new RegExp(params);
        return this.optional(element) || expression.test(value);
      }, "");

      let form = $('#step1').validate({
        rules: {
          client_name: {
            required: true,
            maxlength: 20,
            regexp: /^[а-яА-ЯіІїЇєЄёЁґҐ\'\s]{1,}-?[а-яА-ЯіІїЇєЄёЁґҐ\'\s]+$/

          },
          client_surname: {
            required: true,
            maxlength: 50,
            regexp: /^[а-яА-ЯіІїЇєЄёЁґҐ\'\s]{1,}-?[а-яА-ЯіІїЇєЄёЁґҐ\'\s]+$/
          },
          client_middlename: {
            required: true,
            maxlength: 30,
            regexp: /^[а-яА-ЯіІїЇєЄёЁґҐ\'\s]{1,}-?[а-яА-ЯіІїЇєЄёЁґҐ\'\s]+$/
          },

          sum_credit: {
            required: true,
            max: this.form.credit.max,
            min: this.form.credit.min,
          },
          term_credit: {
            required: true,
            max: this.form.monthInt.max,
            min: this.form.monthInt.min,
          },
          client_date_of_birth: {
            requiredDate: true,
            regDayNew: true,
            // minAge: true,
            // maxAge: true,

          },
          client_phone: {
            required: true,
            minlength: 17,
            maxlength: 17,
            mobileValidate: true,
          },
          applicant_type: {
            selectRequired: "default",
          }
        },
        messages: {
          client_name: {
            required: __t("Заповніть поле"),
            pattern: __t("Це поле может содержать тiльки лiтери"),
            maxlength: __t("Не більше 20 символiв"),
          },
          client_surname: {
            required: __t("Заповніть поле"),
            pattern: __t("Це поле может содержать тiльки лiтери"),
            maxlength: __t("Не більше 50 символiв"),
          },
          client_middlename: {
            required: __t("Заповніть поле"),
            pattern: __t("Це поле может содержать тiльки лiтери"),
            maxlength: __t("Не більше 30 символiв"),
          },
          sum_credit: {
            required: __t('Це поле обов’язкове. Заповніть його'),
            max: __t("Не більше") + ' ' + this.form.credit.max,
            min: __t("Не менше") + ' ' + this.form.credit.min
          },
          term_credit: {
            required: __t('Це поле обов’язкове. Заповніть його'),
            max: __t("Не більше") + ' ' + this.form.monthInt.max,
            min: __t("Не менше") + ' ' + this.form.monthInt.min
          },
          client_date_of_birth: {
            requiredDate: __t('Це поле обов’язкове. Заповніть його'),
            minAge: __t('23 років - мінімальний вік'),
            maxAge: __t('70 років - максимальний вік'),
            regDay: __t("Виправте дату"),
          },
          client_phone: {
            required: __t('Це поле обов’язкове. Заповніть його'),
            minlength: __t('Номер телефону складається з 12 цифр'),
            maxlength: __t('Номер телефону складається з 12 цифр'),
            mobileValidate: __t('Некоректний формат номеру телефона'),
          },
          applicant_type: {
            required: __t("Оберіть один з варіантів типу занятості"),
          }
        },
        errorPlacement: function (error, element) {

          error.insertAfter(element);
          if ($(element).hasClass('limit')) {
            let afterElement = $(element).closest('.range-input-field');
            error.insertAfter(afterElement);
          }
          if ($(element).hasClass('birthday')) {
            let afterElement = $(element).closest('.input-flex-container');
            error.insertAfter(afterElement);
          }
          if ($(element).hasClass('activities')) {
            let afterElement = $(element).closest('.select-wrapper');
            error.insertAfter(afterElement);
          }
        },
        submitHandler: function (form) {
          // var phone = document.querySelector('#step1 input[name=client_phone]').value;
          // if (phone !== '+380(63) 388-9452') {
          //   self.clearForm();
          //   self.openServicesErrorPopup();
          //   return;
          // }

          // if ((self.type_activity >= 5 && self.type_activity <= 9)
          //     || self.type_activity == 99
          // ) {
          //   self.resetValue();
          //   self.showPopupError();
          //   return;
          // } else {
          //   self.openPreloader();
          // }
          self.openPreloader();
          grecaptcha.ready(function () {
            grecaptcha.execute(process.env.CAPTCHA_APP_KEY, {action: 'form'}).then(function (token) {

              self.responseRecaptcha = token;

              // self.openServicesErrorPopup();

              setTimeout(function () {
                var data = $('#step1').serializeArray();
                jQuery.ajax({
                  headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                  },
                  data: data,
                  type: "POST",
                  url: '/cash/step1',
                  cache: false,
                  dataType: "json",
                  success: function (response) {

                    if (response.status == 'error_limit_exceeded_by_phone') {
                      self.$refs.step_preloader.preloaderClose();
                      self.popupErrorPhoneShow = true;
                      self.focusOnClose();
                      self.clearForm();
                      return false;
                    }

                    if (response.status == 'incorrect_type') {
                      self.$refs.step_preloader.preloaderClose();
                      self.resetValue();
                      // self.showPopupError();
                      self.popupErrorShow = true;
                      self.focusOnClose();
                      if (response.message)
                        self.errorMessage = response.message;
                      self.clearForm();
                      return false;
                    }

                    if (response.status == 'incorrect_age') {
                      self.$refs.step_preloader.preloaderClose();
                      self.resetValue();
                      self.popupErrorShow = true;
                      self.focusOnClose();
                      self.clearForm();
                      return false;
                    }

                    if (response.status == 'error_phone') {
                      self.popupReplayError = true;
                      self.focusOnClose();
                    } else {
                      self.gonext();

                    }
                    self.$refs.step_preloader.preloaderClose();
                  },
                  error: function (error) {
                    self.closePreloader();
                    self.errorValidation = error.responseJSON;
                    console.log(self.errorValidation);
                  }
                });
              }, 500);

            });
          });
        }
      });
    },
    showPopupError: function () {

      var self = this;

      grecaptcha.ready(function () {
        grecaptcha.execute(process.env.CAPTCHA_APP_KEY, {action: 'form'}).then(function (token) {

          self.responseRecaptcha = token;

          setTimeout(function () {

            var data = $('#step1').serializeArray();

            jQuery.ajax({
              headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
              },
              data: data,
              type: "POST",
              url: '/cash/step1-refusing',
              cache: false,
              dataType: "json",
              success: (response) => {
                self.popupErrorShow = true;
                self.clearForm();
                self.hideSubmitButton();
              },
              error: function (error) {
                self.errorValidation = error.responseJSON;
              }
            });
          }, 500);

        });
      });

    },
    hideSubmitButton() {
      const self = this;
      createCookie('cash').then(function (data) {
        self.hiddenSubmitButton = data;
      });
    },
    checkHiddenSubmitButton() {
      const self = this;
      readCookie('cash').then(function (data) {
        self.hiddenSubmitButton = data;
      });
    },
    inactivityTime: function () {

      let $this = this;
      var time;
      window.addEventListener('load', resetTimer, true);

      var events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click', 'input', 'change', 'select', 'textarea'];
      events.forEach(function (name) {
        document.addEventListener(name, resetTimer, true);
      });

      function logout() {
        $this.startTime = new Date().getTime();
        events.forEach(function (name) {
          document.removeEventListener(name, resetTimer, true);
        });
        clearTimeout(time);
        $this.openPopupCallback();
      }

      function resetTimer() {
        clearTimeout(time);
        let reset_timer = 180000;
        time = setTimeout(logout, reset_timer);
      }
    },
    sessionTimer: function () {
      let $this = this;
      let timer;
      let reset_timer = +this.abandoned * 60000;
      timer = setTimeout(resetForm, reset_timer);

      var events = ['touchstart', 'click'];
      events.forEach(function (name) {
        document.addEventListener(name, function () {
          clearTimeout(timer);
          timer = setTimeout(resetForm, reset_timer);
          console.log('clearTimeout');

        }, true);
      });

      function resetForm() {
        console.log('resetForm');
        $this.step = 1;
        location.href = location.href;
        $this.resetValue();
        $this.clearForm();
      }

    },
    checkTimer: function () {
      this.reloadAfterClosePopup = false;

      let start = this.startTime;
      let now = new Date().getTime();
      let diff = Math.round(((now - start) / 1000) + +this.timer);
      const $input = this.$refs.popupCallback.$refs.inactive_time;
      $input.value = diff;
    },
    scrollToForm(e) {

      if (e.type === 'keypress' && e.which !== 13) {
          return;
      }

      let $form = $('.vue-form');
      if ($form.length) {
          $('html, body').stop().animate({
              scrollTop: $form.offset().top
          }, 1000, function() {
              let $firstInput = $form.find('input:not([type="hidden"]), select, textarea, button').first();
              
              if ($firstInput.length) {
                  $firstInput.focus();
              } else {
                  $form.attr('tabindex', '-1').focus();
              }
          });
      }

    },
    update(e) {
      this.client_ipn = e.client_inn;
      this.client_birthday = e.client_date_of_birth;
      console.log(this.$refs.step3.$refs.ipn);
      this.$refs.step3.$refs.ipn.value = e.client_inn;
    }

  },
  watch: {
    step() {
      let el = $('.form-scroll:visible');
      if (el.length > 0 && this.step > 1) {
        $('html, body').animate({scrollTop: $(el).position().top}, 500);
      }
    },

    date_birthday: {
      handler(newVal) {
        this.client_birthday = `${newVal.day_birthday}.${newVal.month_birthday}.${newVal.year_birthday}`;
      },
      deep: true,
    },
    isCurrentAccount: {
      handler() {
        this.creditParamsCalculate();
      }
    }
  },
  computed: {
    default__birthday() {
      return `${this.date_birthday.day_birthday}.${this.date_birthday.month_birthday}.${this.date_birthday.year_birthday}`;
    },

    hideStep4: {
      // геттер:
      get: function () {

      },
      // сеттер:
      set: function () {

      }

    },
    getTotalCredit() {
      let tc = this.form.credit.value / 100 * this.form.lifeInsurance + +this.form.credit.value;
      this.form.totalCredit = tc;
      return tc.toFixed(2);
    },

    SumLifeInsurance() {
      return Math.round(this.form.credit.value / 100 * this.form.lifeInsurance)
    },

    monthPaySum() {
      if (this.disabledCalculation) {
        return 0;
      }

      const annualRate = parseFloat(this.form.percentrate) / 100 / 12,
          monthlyCommission = 0,
          months = this.form.monthInt.value,
          sum = this.form.credit.value;

      const x = Math.pow(1 + annualRate, months);
      const monthly = (sum * x * annualRate) / (x - 1);

      return (monthly + (sum * monthlyCommission));
    },
    monthPaySumLabel() {
      return this.monthPaySum.toFixed(2);
    },
    setMask() {
      let str = "" + this.form.credit.max;
      let count_symbols = str.length;
      let mask = '';
      for (let i = 0; i < count_symbols; i++) {
        mask += '#'
      }

      return mask;

    },
    disabledCalculation() {
      return this.form.monthInt.value < this.termmin ||
          this.form.credit.value < this.summin ||
          this.form.monthInt.value > this.termmax ||
          this.form.monthInt.value > this.summax;
    },
    percentageSum() {
      if (this.disabledCalculation) {
        return 0;
      }

      return ((Number(this.monthPaySum) - (this.form.credit.value / this.form.monthInt.value)) * this.form.monthInt.value).toFixed(2);
    },
    consumerSum() {
      if (this.disabledCalculation) {
        return 0;
      }

      return (Number(this.percentageSum)).toFixed(2);
    },
    totalSum() {
      if (this.disabledCalculation) {
        return 0;
      }

      return (Number(this.consumerSum) + Number(this.form.credit.value)).toFixed(2);
    },
    currentAnnualRate() {
      if (this.disabledCalculation || this.monthPaySum === 'NaN') {
        return 0;
      }

      let monthInt = this.form.monthInt.value;

      const months = [];
      const dateStart = moment();

      for (let i = 0; i <= monthInt; i++) {
        months.push({
          amount: i === 0 ? -this.form.credit.value : this.monthPaySum,
          when: dateStart.toDate(),
        })

        dateStart.add(1, 'month');
      }

      return (xirr(months) * 100).toFixed(2);
    },
    calcItems() {
      return [
        {
          label: this.__t('Сума кредиту'),
          value: `${this.form.credit.value} грн`,
        },
        {
          label: this.__t('Строк кредиту'),
          value: `${this.form.monthInt.value} міс`,
        },
        {
          label: this.__t('Річна відсоткова ставка'),
          value: `${this.form.percentrate} %`,
        },
        {
          label: this.__t('Загальні витрати за споживчим кредитом'),
          value: `${this.consumerSum} грн`,
        },
        {
          label: this.__t('Орієнтовна загальна вартість кредиту для клієнта за весь строк користування кредитом'),
          value: `${this.totalSum} грн`,
        },
        {
          label: this.__t('Реальна річна процентна ставка, відсотків річних'),
          value: `${this.currentAnnualRate} %`,
        },
      ];
    },
  },
  mounted: function () {
    this.rangeSlider();
    this.validation();
    this.inactivityTime();
    this.sessionTimer();
    this.$refs.sendForm.disabled = this.cookie || !this.agree;
    this.calcCreditBetween();
    this.calcMonthBetween();
    this.options_birthday_picker.minimumAge = this.clientyearmin;
    this.options_birthday_picker.maximumAge = this.clientyearmax;
    $.dobPicker(this.options_birthday_picker);
    //
    this.checkHiddenSubmitButton();

    //$('.input-info_btn').on('mouseover', function (el) {
    //  this.querySelector('.input-info_popup').style.visibility = "visible";
    //});

    //$('.input-info_btn').on('mouseout', function (el) {
    //  this.querySelector('.input-info_popup').style.visibility = "hidden";
    //});
  }
}
</script>

<style>
.input-hint-wrapper {
  position: relative;
}
/*
.input-info_popup {
  font-size: 14px;
  line-height: 21px;
  color: #333333;
  font-weight: 600;
  width: 260px;
}
  */
.form .half-from-block {
  z-index: unset;
}
.input-info_btn {
  z-index: 2;
}
.form_step-3 .version {
  @media(max-width: 768px) {
    padding: 0 20px;
  }
}
.form_step-3 .input-group_title {
  @media(max-width: 768px) {
    padding: 0 40px;
  }
}
</style>
